import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Container } from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";

function ProgramPageHeader({ id_program }) {
  const pageHeader = useRef(null);
  const [bgImage, setBgImage] = useState("");

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000, // Animation duration
    });

    // Fetch the background image (cover) from the API
    axios
      .get(`${process.env.REACT_APP_API_URL}/program/readProgramById/${id_program}`)
      .then((response) => {
        if (response.data) {
          setBgImage(response.data.cover_foto); // Assuming 'cover_foto' is the image URL
        }
      })
      .catch((error) => {
        console.error("Error fetching background image:", error);
      });

    // Scroll effect for the page header
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        if (pageHeader.current) {
          let windowScrollTop = window.pageYOffset / 3;
          pageHeader.current.style.transform =
            "translate3d(0," + windowScrollTop + "px,0)";
        }
      };
      window.addEventListener("scroll", updateScroll);

      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  }, [id_program]);

  return (
    <div className="page-header page-header-small">
      <div
        className="page-header-image"
        style={{
          backgroundImage: bgImage ? `url(${bgImage})` : "none",
        }}
        ref={pageHeader}
        data-aos="fade-in" // AOS attribute for animation
      ></div>
      <div className="content-center">
        <Container>
          <h2 className="title" data-aos="fade-left">PROGRAM YKBUT</h2>
          <div className="underline" data-aos="fade-right" data-aos-delay="300"></div>
          <div className="text-center" data-aos="fade-up">
            {/* Add more content here if needed */}
          </div>
        </Container>
      </div>
      <style jsx>{`
        .underline {
          width: 200px;
          height: 4px;
          background-color: white;
          margin: 10px auto;
          transition: all 1.5s ease; // Smooth transition for underline
        }
      `}</style>
    </div>
    
  );
}

export default ProgramPageHeader;
